export default "__VITE_ASSET__7T0541_a__";